const pid = $('[name="pid"]').val();
const id = $('[name="Id"]').val();
const $refreshButton = $('button.js-schedule-five-refresh');
const $refreshProjectionsButton = $('button.js-schedule-five-refresh-projections');
const $refreshConfirmButton = $('.js-confirm-refresh-projections');
const $refreshLoader = $('#refreshLoader');
const $refreshWarning = $('#refreshWarning');

const toggleRefreshInfo = async () => {
    const showButton = $refreshButton.prop('disabled') ?? false;
    const showWarning = $refreshWarning.text().length > 0;
    $refreshButton.prop('disabled', !showButton);
    $refreshLoader.toggle();
    if (showWarning) $refreshWarning.show();
    else $refreshWarning.hide();
    return true;
};

const processResponse = async function(data) {
    if (data.success) {
        const menuItem = $('.menu-main__item.menu-main__item--l2.menu-main__item--active')
            .find('a')
            .filter(function() {
                return this.text === 'Schedule 5';
            })[0];
        return menuItem.href;
    }
    throw new Error('Failed to refresh Schedule 5');
};

const refreshData = async function(data) {
    return $.post(`/Operations/ScheduleFive/RefreshData?pid=${pid}`)
        .then(processResponse)
        .catch((error) => {
            throw error;
        });
};

const refreshEvent = async function(e) {
    toggleRefreshInfo()
        .then(refreshData)
        .then((url) => window.location = url)
        .catch((error) => {
            $refreshWarning.text(error.message);
        })
        .finally(toggleRefreshInfo);
};

const attachRefreshEvent = () => {
    $refreshButton.click(refreshEvent);
};


const toggleRefreshProjectionInfo = async () => {
    const showButton = $refreshConfirmButton.prop('disabled') ?? false;
    const showWarning = $refreshWarning.text().length > 0;
    $refreshConfirmButton.prop('disabled', !showButton);
    $refreshLoader.toggle();
    if (showWarning) $refreshWarning.show();
    else $refreshWarning.hide();
    return true;
};

const refreshProjectionData = async function(data) {
    return $.post(`/Operations/ScheduleFive/RefreshProjectionData?id=${id}`)
        .then(processResponse)
        .catch((error) => {
            throw error;
        });
};

const refreshProjectionEvent = async function() {
    toggleRefreshProjectionInfo()
        .then(refreshProjectionData)
        .then((url) => window.location = url)
        .catch((error) => {
            $refreshWarning.text(error.message);
        })
        .finally(toggleRefreshInfo);
};

const attachRefreshProjectionsEvent = () => {
    $refreshProjectionsButton.click(() => {
        const $window = $('#refresh-projections-window');
        const k_window = $window.data('kendoWindow');
        if (!k_window) {
            $window.kendoWindow({
                title: 'Cost Codes With No Projected Hours',
                draggable: false,
                resizable: false,
                visible: true,
                actions: [
                    'Close',
                ],
                close: function() {
                    // restore default scrolling
                    $('html, body').css('overflow', '');
                },
                open: function() {
                    $('#refresh-projections-window').show();
                    const $ele = this.element;
                    // Prevent background scrolling
                    $('html, body').css('overflow', 'hidden');

                    $ele.parent().css('top', '').css('left', '').addClass('centerWindow');

                    $('#no-projections-list').html(
                        '<div class="spinner" id="loading"><span class="spinner__text">Loading Cost Codes...</span></div>',
                    );

                    $.get(`/Operations/ScheduleFive/CostCodesWithNoProjectedHours?id=${id}`, (response) => {
                        if (!response.success) {
                            return;
                        }
                        let output = '';
                        $.each(response.costCodeList, (index, element) => {
                            output += `<div>${element.Name}</div>`;
                        });

                        if (output === '') {
                            output = 'All cost codes have projected hours';
                        }
                        $('#no-projections-list').html(output);
                    });

                    const thisWindow = this;
                    $('.js-confirm-refresh-projections').click(refreshProjectionEvent);
                    $('.js-cancel-refresh-projections').click(function() {
                        thisWindow.close();
                    });
                },
                maxWidth: 1080,
                maxHeight: 800,
            });
        } else {
            k_window.open();
        }
    });
};

export default function() {
    attachRefreshEvent();
    attachRefreshProjectionsEvent();
}
